import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import styled from "styled-components"
import { Button } from "../../themed-html-components"
import CustomReportSubmitSpinner from "./CustomReportSubmitSpinner"

const IntroArea = styled.div`
  margin-left: 20px;
`

class CustomReportSubmitModal extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    closePopup: PropTypes.func.isRequired,
    submitInProgress: PropTypes.bool.isRequired,
  }

  closeModal = () => {
    this.props.closePopup()
  }

  render() {
    const { t, submitInProgress } = this.props

    return (
      <Modal isOpen toggle={this.closeModal}>
        <ModalHeader toggle={this.closeModal}>{t("CustomReport.Submit.ModalTitle")}</ModalHeader>
        <ModalBody>
          {submitInProgress ? <CustomReportSubmitSpinner /> : null}
          {!submitInProgress ? (
            <IntroArea>
              <p>{t("CustomReport.Submit.ModalGenerateMessage")}</p>
              <p>{t("CustomReport.Submit.ModalCompleteInfo")}</p>
            </IntroArea>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button inverted onClick={this.closeModal}>
            {t("Common.OK")}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
    submitInProgress: state.customReport.reportSubmitInProgress,
  }
}

export default compose(translate(), connect(mapStateToProps))(CustomReportSubmitModal)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/CustomReportSubmitModal.jsx